import { makeStyles } from '@fluentui/react-components';

export const useAssetTableStyles = makeStyles({
  headerRow: {
    borderBottomStyle: 'none',
  },
  conversionsHeader: {
    width: '137px',
  },
  performanceHeader: {
    width: '137px',
  },
  policyStatusHeader: {
    width: '109px',
  },
  headerText: {
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  performanceCell: {
    borderRightStyle: 'solid',
    borderRightWidth: '1px',
    borderRightColor: '#E0E0E0',
    borderLeftStyle: 'solid',
    borderLeftWidth: '1px',
    borderLeftColor: '#E0E0E0',
  },
});
